module.exports = __webpack_public_path__ + "img/1_025.0e837ed3.jpg";